import { IEnvironment } from './environment.interface';

export const api = {
	base_url: 'https://trieonhr-api-dev-h3gzhefkene3fjb5.eastasia-01.azurewebsites.net',
	base_api_root: 'https://trieonhr-api-dev-h3gzhefkene3fjb5.eastasia-01.azurewebsites.net/api/v1',
};

export const environment: IEnvironment = {
	production: false,
	name: 'DEV',
	site_version: '1.0.0',
	api_base_url: api.base_api_root,
	subscription_api_base_url: 'https://trieonhr-subscription-dev-amcabyh8f8emgybm.eastasia-01.azurewebsites.net/api/sub',
	api_token: 'token',
	api_refresh_token: 'refresh_token',
	user_payload: 'user_payload',
	socket: `${api.base_api_root}/socket`,
	signalrHubUrl: `${api.base_url}/hubs/app`,
	signalnotificationHubUrl: `${api.base_url}/hubs/notification`,
	user: {
		validate: `${api.base_api_root}/auth/validate-user`,
		auth: `${api.base_api_root}/auth/request-token`,
		refresh: `${api.base_api_root}/auth/request-refresh-token`,
		logout: `${api.base_api_root}/auth/logout`,
		register: `${api.base_api_root}/auth/register`,
		root: `${api.base_api_root}/user-profiles`,
		verifyEmail: `${api.base_api_root}/auth/verify-email`,
		resendVerificationEmail: `${api.base_api_root}/auth/resend-verification-email`,
	},
	employee: {
        root: `${api.base_api_root}/employees`,
        profilePhoto: (guid: string) => `${api.base_api_root}/employees/${guid}/profile-photo`,
    },
	organization: {
		root: `${api.base_api_root}/organization`,
	},
	dtr: {
		entries: `${api.base_api_root}/dtr-entries`,
		submissions: `${api.base_api_root}/dtr-submissions`,
	},
	payroll: {
		schedules: `${api.base_api_root}/payroll-schedules`,
		periods: `${api.base_api_root}/payroll-periods`,
		allowanceTypes: `${api.base_api_root}/allowance-types`,
		deductionTypes: `${api.base_api_root}/deduction-types`,
		contributionSettings: `${api.base_api_root}/contribution-settings`,
		taxBrackets: `${api.base_api_root}/tax-brackets`,
		runs: `${api.base_api_root}/payroll-runs`,
                employeeDeductions: `${api.base_api_root}/employee-deductions`,
                employeeAllowances: `${api.base_api_root}/employee-allowances`,
                thirteenthMonth: `${api.base_api_root}/thirteenth-month`,
                finalPay: `${api.base_api_root}/final-pay`,
                salaryAdjustments: `${api.base_api_root}/salary-adjustments`,
        bankExportProfiles: `${api.base_api_root}/bank-export-profiles`,
        payslipTemplate: `${api.base_api_root}/payslip-template`,
            },
	roles: {
			root: `${api.base_api_root}/roles`,
			userRoles: `${api.base_api_root}/user-roles`,
			modules: `${api.base_api_root}/roles/modules`,
	},
	approval: {
		policies: `${api.base_api_root}/approval-policies`,
		departmentPolicies: `${api.base_api_root}/approval-policies/departments`,
		delegates: `${api.base_api_root}/approval-delegates`,
	},
	leave: {
			types: `${api.base_api_root}/leave-types`,
			requests: `${api.base_api_root}/leave-requests`,
			balances: `${api.base_api_root}/leave-balances`,
	},
	overtime: {
			requests: `${api.base_api_root}/overtime-requests`,
	},
	timeCorrectionRequests: {
			root: `${api.base_api_root}/time-correction-requests`,
	},
	announcements: {
			root: `${api.base_api_root}/announcements`,
			active: `${api.base_api_root}/announcements/active`,
	},
	approvalInstances: {
			root: `${api.base_api_root}/approval-instances`,
			byRequest: `${api.base_api_root}/approval-instances/by-request`,
        pendingByApprover: `${api.base_api_root}/approval-instances/pending-by-approver`,
        historyByApprover: `${api.base_api_root}/approval-instances/history-by-approver`,
	},
	documentRequests: {
			root: `${api.base_api_root}/document-requests`,
			attachments: (guid: string) => `${api.base_api_root}/document-requests/${guid}/attachments`,
	},
	auditLogs: {
		root: `${api.base_api_root}/audit-logs`,
	},
	attendance: {
		root: `${api.base_api_root}/attendance`,
		todayStatus: `${api.base_api_root}/attendance/today-status`,
		biometricClock: `${api.base_api_root}/attendance/biometric-clock`,
	},
	holidays: {
		root: `${api.base_api_root}/holidays`,
	},
	minimumWageRates: {
		root: `${api.base_api_root}/minimum-wage-rates`,
	},
	loans: {
		types: `${api.base_api_root}/loan-types`,
		applications: `${api.base_api_root}/loan-applications`,
	},
        governmentReports: {
                root: `${api.base_api_root}/government-reports`,
        },
        reportTypes: {
                root: `${api.base_api_root}/report-types`,
        },
        reportGenerations: {
                root: `${api.base_api_root}/report-generations`,
        },
        reportPdf: {
                root: `${api.base_api_root}/report-pdfs`,
        },
        reportExcel: {
                root: `${api.base_api_root}/report-excels`,
        },
        reportEprs: {
                root: `${api.base_api_root}/report-eprs`,
        },
}